module.exports = __webpack_public_path__ + "static/media/no-image-bis.731c36a3.jpg";